import { render } from "./PPromotionDetails.vue?vue&type=template&id=595431e6&scoped=true"
import script from "./PPromotionDetails.vue?vue&type=script&lang=js"
export * from "./PPromotionDetails.vue?vue&type=script&lang=js"

import "./PPromotionDetails.vue?vue&type=style&index=0&id=595431e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595431e6"]])

export default __exports__